import React from 'react'
// libs
import { ReduxEntitySelect, ReduxInput, ReduxSelect } from 'components/FormElements'
// constants
import { FORM_POSITION_OPTIONS } from 'constants/systemProcesses'
// types
import { IOption } from 'components/FormElements/Select'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// views
import { ShowFunctionWrapper } from './views'
// graphql
import { RISK_TEMPLATE_SELECT_QUERY } from 'graphql/risk/queries'
// utils
import { required } from 'utils/validators'
import { riskTemplatesProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

interface Props {
  field: string
}

const ShowInlineFunction: React.FC<Props> = ({ field }) => {
  const { riskTemplate } = React.useContext(RiskTemplateAPIContext)

  const ids = riskTemplate.fieldLinks.map((item) => item.field.entityId)

  const prepareFieldsOptions = (options: IOption[]): IOption[] => {
    return riskTemplate.fieldLinks
      .filter((fieldLink) => fieldLink.primary)
      .map((fieldLink) => {
        const parent = riskTemplate.fields.find((field) => field.id === fieldLink.parentFieldId)?.label
        const template = options.find((template) => template.value === fieldLink.field.entityId)?.label

        return { label: `${parent}: ${template}`, value: fieldLink.id }
      })
  }

  return (
    <ShowFunctionWrapper>
      <ReduxInput validate={required} label='Function Name' name={`${field}.functionName`} />
      <ReduxEntitySelect
        label='Form'
        validate={required}
        menuPortalTarget={null}
        name={`${field}.fieldLinkId`}
        query={RISK_TEMPLATE_SELECT_QUERY}
        prepareOptions={prepareFieldsOptions}
        variables={{ filter: { ids } }}
        {...riskTemplatesProps}
      />
      <ReduxSelect
        label='Position'
        validate={required}
        menuPortalTarget={null}
        name={`${field}.position`}
        options={FORM_POSITION_OPTIONS as unknown as IOption[]}
      />
    </ShowFunctionWrapper>
  )
}

export default ShowInlineFunction
